import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {rulesMap} from 'go/components/rules/rules';
import {DynamicTextAreaField as _DynamicTextAreaField} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicTextAreaField';

export const DynamicTextAreaField = (props) => (
  <_DynamicTextAreaField {...props} {...{rulesMap}} />
);
export default connectWithCore(DynamicTextAreaField);
